define('modules/integrations/services/api/secretData/view',['require','exports','module','views/BaseView','ldsh!./template'],function (require, exports, module) {
  'use strict';

  var BaseView = require('views/BaseView');

  var Layout = BaseView.extend({
    template: require('ldsh!./template'),

    initialize: function () {},

    initEvents: function () {
      this.$el.find('.secret__message--copy').on('click', function () {
        var $this = $(this),
          $input = $this.siblings('.secret__message--input'),
          $message = $this.siblings('.secret__message--text');

        $input.select();
        $message.fadeIn(200);
        document.execCommand('copy');

        setTimeout(function () {
          $input.removeAttr('readonly').blur().attr('readonly');
          $message.fadeOut(200);
        }, 2000);
      });
    },

    afterRender: function () {
      this.initEvents();
      this.$el.i18n();
    },

    serialize: function () {
      return {
        apiData: this.options.apiData
      };
    }
  });

  module.exports = Layout;
});

